import React from "react";
import PropTypes from 'prop-types';
import MainTitle from './MainTitle';
import TextBlock from './TextBlock';
import RoundedLink from '../../elements/RoundedLink';
import { freeTrialLink } from '../../../config/app';

export default class TopFeatureBlock extends React.PureComponent {
    render() {
        let { title, text, className, monthPlan } = this.props;

        return (
            <div className={'feature-block ' + className}>
                <MainTitle text={title}/>

                <TextBlock text={text}/>

                <div className={'control'}>
                    <RoundedLink
                        link={freeTrialLink}
                        text={'Subscribe now'}
                    />
                    <div className={'label'}>
                        {monthPlan.trial_duration}-day free trial then ${monthPlan.price} monthly
                    </div>
                </div>
            </div>
        );
    }
}

TopFeatureBlock.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    monthPlan: PropTypes.object.isRequired,
    className: PropTypes.string,
};
